import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-[68px] px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 group cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
            <i className="ri-flashlight-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-black text-lg tracking-wide transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              快猫
            </span>
            <span
              className={`text-[10px] tracking-[0.25em] transition-colors ${
                scrolled ? "text-foreground-500" : "text-background-200"
              }`}
            >
              KUAIMAO
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#live"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer transition-colors"
          >
            <i className="ri-live-line"></i>
            开始浏览
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              scrolled ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 max-h-[70vh] overflow-y-auto">
          <nav className="grid grid-cols-2 gap-2 p-4">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-600 cursor-pointer transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}